var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdvanceautomation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 91,
    viewBox: "0 0 94 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.0065 3.77817L93.1204 1L91.6431 23.2253L84.2567 16.2799C84.2567 16.2799 67.577 33.9058 63.5747 35.7271C59.5724 37.5483 55.5973 29.0595 53.2337 30.1707C50.2792 31.5598 39.0819 44.2777 36.9836 46.8397C34.8853 49.4018 28.2484 41.8699 23.688 42.6725C19.1276 43.4751 8.91507 59.3415 8.91507 59.3415C1.8241 62.6753 -0.0668682 56.5633 1.52865 53.7852C3.12416 51.007 20.7334 34.338 20.7334 34.338C22.7031 32.0229 24.3801 29.646 26.6425 31.5598C28.9049 33.4737 34.0289 37.1162 38.4608 34.338C42.8926 31.5598 53.2336 13.5017 56.1882 19.0581C58.5519 23.5031 63.0822 24.6144 65.0519 24.6144L76.8702 10.7236L68.0065 3.77817Z",
    fill: "#FFFBFB",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1149 89.9013V37.1161H82.2512V89.9013H91.1149Z",
    fill: "white",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9099 89.9013V45.4507H63.0461V89.9013H71.9099Z",
    fill: "white",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1823 89.9014V53.7853H45.3186V89.9014H54.1823Z",
    fill: "white",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5007 89.9013V62.1196H24.637V89.9013H33.5007Z",
    fill: "white",
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7729 89.9013V70.4541H6.90918V89.9013H15.7729Z",
    fill: "white",
    stroke: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvanceautomation);
export default __webpack_public_path__ + "static/media/Advanceautomation.1f27b561ef27e2d3abc7c3fe652d3b78.svg";
export { ForwardRef as ReactComponent };